import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import ParallaxLayer from "./ParallaxLayer";
import Utils from "@base/utils/Utils";
import gsap from "gsap";

export default class ParallaxContainer extends BaseContainer {

  constructor() {
    super()

    // Block Size: 2450 * 604
    // Static (max) layer width is 2450 * 3
    this.settings = {
      speed: 1,
      layers: [
        {
          name: 'Middle layer with big background images',
          speedMultiplier: 1,
          gap: 0,
          objects: Utils.shuffle([
            {
              name: 'parallax/bgSecA',
              scale: 0.45,
              y: 0
            },
            {
              name: 'parallax/bgSecB',
              scale: 0.45,
              y: 0
            },
            {
              name: 'parallax/bgSecC',
              scale: 0.45,
              y: 0
            },
            {
              name: 'parallax/bgSecD',
              scale: 0.45,
              y: 0
            },
          ])
        },
      ]
    }

    this.parallax = new PIXI.Container()
    this.parallax.name = "Parallax"

    this.addChild(this.parallax)

    this.init(this.settings)
  }

  init(settings) {
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.roundStart.add(this.onRoundStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)

    this.layers = settings.layers.map((layerSetting, i) => {
      const layer = new ParallaxLayer(layerSetting, settings)
      this.parallax.addChild(layer)
      return layer
    })
  }

  reset() {
    this.layers.forEach(layer => layer.reset())
  }

  update() {
    this.layers.forEach(layer => layer.move())
  }

  slowDown() {
    return new Promise((resolve, reject) => {
      let speedBreak = 1;
      let interval = 0;

      interval = setInterval(() => {
        if (speedBreak <= 0) {
          clearInterval(interval)
          resolve()
        }
        speedBreak -= 0.011
        this.layers.forEach(layer => layer.move(speedBreak))
      }, 26)
    });
  }

  onMakeBets() {
    Signals.tick.remove(this.update, this)

    this.reset()
  }

  onRoundEnd() {
    Signals.tick.remove(this.update, this)
    this.slowDown().then(() => { })
  }

  onRoundStart() {
    this.reset()

    Signals.tick.add(this.update, this)
  }
}
